import { useEffect, useState } from 'preact/hooks';
import { SiteLayout } from '../../components/SiteLayout';
import { ErrorBox, Loading } from '../../components/ui';
import { usePageMeta } from '../../lib/meta';

interface Credit { file: string; usedOn: string; title: string; author: string; license: string; licenseUrl: string | null; source: string; modifications: string }

export function Credits() {
  usePageMeta('Photo credits', 'Attribution for the photographs used on the Ayonix Studio website.');
  const [list, setList] = useState<Credit[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    fetch('/img/CREDITS.json').then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))).then(setList).catch((e) => setError(`Credits couldn’t be loaded (${(e as Error).message}).`));
  }, []);
  return (
    <SiteLayout>
      <article class="container prose">
        <header class="page-hero"><h1>Photo credits</h1><p class="muted">Photographs from Wikimedia Commons, used under their Creative Commons licences.</p></header>
        {error && <ErrorBox message={error} />}
        {!list && !error && <Loading />}
        {list && (
          <ul class="credits" data-testid="credits">
            {list.map((c) => (
              <li key={c.file} class="credit">
                <img src={c.file.replace('.webp', '-960.webp')} alt="" width="240" height="135" loading="lazy" />
                <div>
                  <strong>{c.title.replace(/\.[a-z]+$/i, '')}</strong>
                  <span>by {c.author} · {c.licenseUrl ? <a href={c.licenseUrl} rel="noopener license" target="_blank">{c.license}</a> : c.license}</span>
                  <span class="muted small">Used on: {c.usedOn}. {c.modifications}.</span>
                  <a href={c.source} rel="noopener" target="_blank">Source on Wikimedia Commons</a>
                </div>
              </li>
            ))}
          </ul>
        )}
        <p class="muted small">App screenshots show Ayonix Studio builds (web, macOS, Windows and iOS Simulator) captured from the running software. The Ayonix logo is © Ayonix.</p>
      </article>
    </SiteLayout>
  );
}
